// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IPhotoLabel {
  /** Цвет лейбла **/
  color: EColor;
  /** Текст лейбла **/
  name: string;
}

export enum EColor {
  /** Синий **/
  'Blue' = 'blue',
  /** Синий для Хорошая цена **/
  'BlueGoodPrice' = 'blueGoodPrice',
  /** Мгновенное бронирование **/
  'BlueInstantBooking' = 'blueInstantBooking',
  /** Синий для бронирования через партнёра **/
  'BlueNewbuildingBrokerBooking' = 'blueNewbuildingBrokerBooking',
  /** Синий для только для Циан **/
  'BlueOnlyCian' = 'blueOnlyCian',
  /** Проверено Циан **/
  'BlueVerifiedByCian' = 'blueVerifiedByCian',
  /** Зеленый **/
  'Green' = 'green',
  /** Зеленый для проверенного собственника **/
  'GreenForCheckedOwner' = 'greenForCheckedOwner',
  /** Зеленый для собственника **/
  'GreenForOwner' = 'greenForOwner',
  /** Зеленый для Суперагент **/
  'GreenForSuperAgent' = 'greenForSuperAgent',
  /** Зеленый для Суперхозяина **/
  'GreenForSuperHost' = 'greenForSuperHost',
  /** Зеленый для премиум сниппета **/
  'GreenPremium' = 'greenPremium',
  /** Серый **/
  'Grey' = 'grey',
  /** Оранжевый **/
  'Orange' = 'orange',
  /** Оранжевый для субсидированной ипотеки **/
  'OrangeSubsidisedMortgage' = 'orangeSubsidisedMortgage',
  /** Сиреневый для льготной ипотеки **/
  'PurpleDiscountMortgage' = 'purpleDiscountMortgage',
  /** Фиолетовый для раннего доступа **/
  'PurpleEarlyAccess' = 'purpleEarlyAccess',
  /** Белый **/
  'White' = 'white',
}
